import Vue from "vue"
import App from "./App.vue"
import "normalize.css/normalize.css"
import Cookies from "js-cookie"
import Element from "element-ui"
import AFTableColumn from "af-table-column"
import Dialog from "@/components/Dialog"
import Folding from "@/components/Folding"
import Pagination from "@/components/Pagination"
import "element-ui/lib/theme-chalk/index.css"
import "@/styles/index.scss"
import store from "./store"
import router from "./router"
import "./icons"
import "@/permission"
import * as filters from "./filters" // global filters
import "@/utils/bus.js"
import Viewer from "v-viewer"
import "viewerjs/dist/viewer.css"
import * as echarts from "echarts"

Vue.prototype.$echarts = echarts
import "@/directive/watermark"
import waves from "@/directive/waves"
import elTable from "@/directive/el-table"
import vueSeamlessScroll from "vue-seamless-scroll"

import BaiduMap from "vue-baidu-map"

Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	ak: "idPM35QUeKoZcxO35lRhzOB3LDHfErTn"
})

Vue.use(vueSeamlessScroll)
// import Plugin from 'v-fit-columns';
// Vue.use(Plugin);
// import elFocus from "@/directive/el-focus"
// import Plugin from 'v-fit-columns';
// Vue.use(Plugin);
Vue.use(Viewer)
const fontRate = {
	CHAR_RATE: 1.1, // 汉字比率
	NUM_RATE: 0.65, // 数字
	// OTHER_RATE:100 // 除汉字和数字以外的字符的比率
	// OTHER_RATE:10 // 除汉字和数字以外的字符的比率
	OTHER_RATE: 0.8 // 除汉字和数字以外的字符的比率
}
// const fontSize = 1
const fontSize = 20
//注册组件
Vue.use(AFTableColumn, {fontRate, fontSize})
// Vue.use(AFTableColumn)
// Vue.use(AFTableColumn)
// Viewer.setDefaults({
//   Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
// })

Vue.config.productionTip = false
if (process.env.NODE_ENV === "production") {
	const {mockXHR} = require("../mock")
	mockXHR()
}
Vue.use(Element, {
	size: Cookies.get("size") || "small" // set element-ui default size
})
Vue.use(Dialog)
Vue.use(Folding)
Vue.use(Pagination)
Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key])
})
Vue.directive("waves", waves)
Vue.directive("elTable", elTable)
// Vue.directive('elFocus',elFocus)

Vue.directive("debounce", {
	inserted(el, binding, vnode) {
		let timer = {}
		el.addEventListener("click", () => {
			if (timer) {
				clearTimeout(timer)
			}
			timer = setTimeout(() => {
				binding.value()
			}, 500)
		})
	}
})
Vue.directive("title", {
	inserted: function (el, binding, vnode) {
		/** el可以获取当前dom节点，并且进行编译，也可以操作事件 **/
		/** binding指的是一个对象，一般不用 **/
		/** vnode 是 Vue 编译生成的虚拟节点 **/
		// el.style.border = "1px solid red" //操作style所有样式
		// console.log(el.value) //获取v-model的值
		// console.log(el.dataset.title) //data-name绑定的值，需要el.dataset来获取
		// console.log(el.dataset.name) //data-name绑定的值，需要el.dataset来获取
		// console.log(vnode.context.$route) //获取当前路由信息
		//给v-title标签的 data-title 属性赋值
		document.title = el.dataset.title
	}
})

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount("#app")

console.log('build time:', process.env.APP_VERSION)
